import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

const SectionPaper = ({ title, titleAdornment, children, sx, ...props }) => {
    return (
        <Paper variant="outlined" sx={ { p: 2, backgroundColor: 'background.paper', ...sx } } { ...props }>
            { (title || titleAdornment) && (
                <Box sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 } }>
                    { title && (
                        <Typography
                            variant="subtitle2"
                            color="textSecondary"
                            sx={ { textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.5px' } }
                        >
                            { title }
                        </Typography>
                    ) }
                    { titleAdornment && (
                        <Box>
                            { titleAdornment }
                        </Box>
                    ) }
                </Box>
            ) }
            { children }
        </Paper>
    );
};

export default SectionPaper;